/**
 * Фільтри списку в першому екрані (E4a-W4; FLT-10, FLT-11): чипи, кнопки «+ Фільтр» і «Фільтр · N»,
 * короткі підписи операторів і токени для тексту чипа і зведення людською мовою. Тексти конструктора
 * (зокрема повні підписи операторів FLT-12), меню полів і бічної панелі — лінивий простір
 * `filter-tools.ts`. У `uk.ts` не реєструється (його тягне документ входу), перетин ключів ловить
 * `uk.test.ts` (`lazyOnly`).
 */
export const filters = {
  addFilter: 'Фільтр',
  addFilterLabel: 'Додати фільтр',
  /** Кнопка бічної панелі з кількістю умов. */
  filterCount: (n: number) => `Фільтр · ${n}`,
  filterButton: 'Фільтр',
  filterButtonHint: 'Розширений фільтр: умови І / АБО',
  /** Один чип замість окремих, коли корінь — АБО або є групи (FLT-11). */
  advancedChip: (conditions: string) => `Розширений фільтр · ${conditions}`,
  conditionForms: { one: 'умова', few: 'умови', many: 'умов' },
  /** «+N»: чипи, що не вмістилися. */
  moreChips: (n: number) => `+${n}`,
  moreChipsLabel: (n: number, list: string) => `Ще ${n}: ${list}`,
  chipsLabel: 'Фільтри списку',
  removeFilter: (label: string) => `Прибрати фільтр «${label}»`,
  editFilter: (text: string) => `Змінити фільтр: ${text}`,
  filterRemoved: (label: string) => `Фільтр «${label}» прибрано`,
  filterRemovedAll: 'Фільтри прибрано',
  /** Фільтр з полями `personal` / `sensitive` в адресу не йде (SEC-110). */
  filterNotInLink: 'Фільтр з особистими даними не потрапляє в посилання на цю сторінку',
  /** Смужка прогресу, поки йде запит з новим фільтром (FLT-18). */
  searching: 'Шукаємо…',
  /** Помилка завантаження чанка фільтрів. */
  toolsFailed: 'Фільтр не відкрився. Спробуйте ще раз',
  /** Умова подання недоступна (поле приховане роллю). */
  viewUnavailable: 'Подання недоступне: його умова використовує поле, приховане для вашої ролі',

  // ---------------------------------------------------------------- зведення людською мовою
  and: 'І',
  or: 'АБО',
  /** Значення умови не вдалося показати (поле зникло з `/meta`). */
  unknownField: (key: string) => `поле ${key}`,
  yes: 'так',
  no: 'ні',
  people: { one: 'людина', few: 'людини', many: 'людей' },
  records: { one: 'запис', few: 'записи', many: 'записів' },
  /** Короткі форми операторів у чипі: «Етап: не А, Б», «Сума: від 20 000 ₴». */
  chipOp: {
    neq: 'не',
    not_in: 'не',
    has_none: 'жодного з',
    has_all: 'усі',
    lt: 'менше',
    lte: 'до',
    gt: 'більше',
    gte: 'від',
    before: 'до',
    after: 'після',
    starts_with: 'починається з',
    currency_in: 'валюта',
  } as Readonly<Record<string, string>>,
  isNull: 'порожнє',
  notNull: 'не порожнє',
  excludeEmpty: 'без порожніх',
  betweenRange: (from: string, to: string) => `${from} – ${to}`,
  quoted: (text: string) => `«${text}»`,

  // ---------------------------------------------------------------- токени (FLT-13, FLT-14)
  token: {
    me: 'я',
    my_teams: 'мої команди',
    my_unit: 'мій підрозділ',
    my_unit_tree: 'мій підрозділ з дочірніми',
    inactive_users: 'неактивні користувачі',
    today: 'сьогодні',
    yesterday: 'вчора',
    tomorrow: 'завтра',
    this_week: 'цей тиждень',
    last_week: 'минулий тиждень',
    next_week: 'наступний тиждень',
    this_month: 'цей місяць',
    last_month: 'минулий місяць',
    next_month: 'наступний місяць',
    this_quarter: 'цей квартал',
    last_quarter: 'минулий квартал',
    next_quarter: 'наступний квартал',
    this_year: 'цей рік',
    last_year: 'минулий рік',
    next_year: 'наступний рік',
    now: 'зараз',
  } as Readonly<Record<string, string>>,
  days: { one: 'день', few: 'дні', many: 'днів' },
  daysAgo: (days: string) => `${days} тому`,
  daysAhead: (days: string) => `через ${days}`,
  lastNDays: (days: string) => `останні ${days}`,
  nextNDays: (days: string) => `наступні ${days}`,
};
